import { Component, Input, OnInit } from '@angular/core';
import {
  HANDOVER_STATUS_ACCEPTED,
  HANDOVER_TYPE_HO5_ID,
} from 'src/app/handover-constants';
import {
  Perforation,
  PerforationsByWellbore,
} from 'src/app/interfaces/perforation';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-perforation',
  templateUrl: './handover-detail-perforation.component.html',
  styleUrls: ['./handover-detail-perforation.component.scss'],
  standalone: false,
})
export class HandoverDetailPerforationComponent implements OnInit {
  @Input() handoverId: number | undefined;
  @Input() wellId: string | undefined;
  @Input() handoverStatusId: number | undefined;
  @Input() handoverTypeId: number | undefined;
  @Input() readOnlyContent: boolean | undefined;
  @Input() wellUwi: string | undefined;

  perforations: Perforation[] = [];
  perforationsByWellbore: PerforationsByWellbore = {};
  perforationsByWellboreLenght = 0;
  isLoadingPerforations = false;

  displayedColumns = ['wellboreNo', 'mdTop', 'mdBase', 'jobEnd'];
  hideFooter = true;

  isDisabled: boolean[] = [];
  showFooterNoDataOrign = false;

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellId) {
      this.setPerforationsDataSource();
      this.showFooterNoDataOrign =
        this.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
    if (this.handoverTypeId == HANDOVER_TYPE_HO5_ID) {
      this.displayedColumns.push('numIntervals');
      this.displayedColumns.push('shotDensityAverage');
      this.displayedColumns.push('carrierSizeAvg');
      this.displayedColumns.push('chargeSizeAvg');
    }
  }

  setPerforationsDataSource(): void {
    this.isLoadingPerforations = true;
    this.handoverService
      .getPerforations(this.handoverId!, this.wellId!, this.handoverStatusId!)
      .subscribe((p: Perforation[]) => {
        this.perforations = p;
        this.perforationsByWellbore = this.groupPerforationsByWellbore(p);
        this.perforationsByWellboreLenght = Object.keys(
          this.perforationsByWellbore
        ).length;
        this.isLoadingPerforations = false;
        this.hideFooter = p.length > 0;
      });
  }

  private groupPerforationsByWellbore(arr: any) {
    return arr.reduce((group: any, perfo: any) => {
      const { wellboreNo } = perfo;
      group[wellboreNo] = group[wellboreNo] ?? [];
      group[wellboreNo].push(perfo);
      return group;
    }, {});
  }
}
